<template>
    <div>
        <a class="dropdown-item" href="#" @click="baseModalOpen = true">
            <i class="ks-icon fa la-fw fa-tags"></i>
            <span>Attributes</span>
        </a>
        <transition name="fade">
            <div v-if="baseModalOpen" class="modal-wrapper">
                <div class="modal-bg" @click="baseModalOpen = false"></div>
                <div class="d-flex flex-column modal-inner p-4 w-100" style="max-width: 42rem;">
                    <transition name="fade">
                        <div class="row mx-4 pb-1 mt-3 d-flex flex-column">
                            <div class="row my-4 py-0 w-100 mx-auto d-flex flex-column">
                                <div class="col-md-12">
                                    <h4 class="mt-0 mb-6 wizard-title">
                                        Do you want us to send this report by email once its generated?
                                    </h4>
                                </div>
                            </div>
                            <div class="row my-0 py-0 w-100 mx-auto d-flex flex-column">
                                <div class="col-md-12">
                                    <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" data-id="wizard-email-list" v-model="emailList">
                                    <small id="emailHelp" class="form-text text-muted">Email addresses separated by comma.</small>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <div class="row mx-4 mt-4 mb-4 pb-0">
                        <div class="row my-0 py-0 w-100 mx-auto">
                            <div class="col-md-8">
                                <button class="btn my-2 btn-outline-secondary" @click="generateReport(false)">
                                    No, I'll get the link from the job
                                </button>
                                <button class="btn my-2 ml-2 btn-primary" @click="generateReport()">
                                    Yes, please
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import axios from "axios";

const base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: "input-email-wizard",
    props: {
        userEmail: String
    },
    data() {
        return {
            baseModalOpen: false,
            alert: {
                status: 'alert-danger',
                message: '',
                timeOut: 20000
            },
            emailList: '',
            userInfo: '',
        }
    },
    methods: {
        generateReport(withEmails = true) {
            let emails = ''
            if(withEmails){
                emails = this.emailList
            }
            axios.post(base_url + '/export-attributes', {
                emailList: emails,
            })
            .then(function(response) {
                window.location.href = base_url + '/jobs'
            }.bind(this))
            .catch(function(err) {
                console.log(err)
            }.bind(this));
        },
        getUserInfo(){
            axios.get(base_url + '/user/info')
            .then((response) => {
                this.userInfo = response.data
            })
            .catch((error) => {
                console.log(error);
            });
        }
    },
    mounted() {
        this.getUserInfo();
    },
    watch: {
        userInfo: {
            handler() {
                this.emailList = this.userInfo.email;
            },
            deep: true
        },
    }
}
</script>

<style lang="scss" scoped>
.wizard-title {
    max-width: 40ch;
    margin-bottom: 1rem !important;
}
</style>
